module.exports = __webpack_public_path__ + "static/img/04.c9a47aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/06/04.jpg
// module id = Ew73
// module chunks = 0